import * as types from "../ActionType";
import axios from "axios";
import { notifyError, notifysuccess, staticc } from "../../Components/General/Notification";

const getStories = (allStories) => {
    return ({
        type: types.GET_ALL_STROIES,
        payload: allStories
    })
}

const getStoryDetails = (storyDetails) => {
    return ({
        type: types.GET_STROIY_DETAILS,
        payload: storyDetails
    })
}

const delStories = () => {
    return ({
        type: types.DELETE_STROIY
    })
}

const addStories = () => {
    return ({
        type: types.ADD_STROIY
    })
}

const delStoryDetails = () => {
    return ({
        type: types.DELETE_STROIY_DETAILS
    })
}

const emptyGeneral = (empty, typee) => {
    return ({
        type: typee,
        payload: empty
    })
}


export const loadStories = () => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/stories`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getStories(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const deleteStories = (id) => {
    return function (dispatch) {
        //setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/story_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delStories());
                dispatch(loadStories());
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const deleteStoryDetails = (s_id, id) => {
    return function (dispatch) {
        //setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        axios.post(`${staticc}/api/story_details_delete`, { id }, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(delStoryDetails());
                dispatch(loadStoryDetails(s_id));
                notifysuccess(res.data.message)
                //setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            //setloabBtn(false)
            notifyError(err.response.data.message)
        })
    }
}

export const loadStoryDetails = (id) => {
    return function (dispatch) {
        let token = localStorage.getItem("tokenA");
        axios.get(`${staticc}/api/stories?id=${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(getStoryDetails(res.data.data));
            }
        }).catch((err) => {
            console.log(err)
            notifyError(err.response.data)
        })
    }
}

export const emptyStoryDetails = () => {
    return function (dispatch) {
        let emptyy = []
        dispatch(emptyGeneral(emptyy, types.EMPTY_STROIY_DETAILS))
    }
}

export const postStory = (vendor_id, description, image, video, setloabBtn) => {
    return function (dispatch) {
        setloabBtn(true)
        let token = localStorage.getItem("tokenA");
        const Dataa = new FormData();
        /*if (image == '') {
            Dataa.append('vendor_id', vendor_id);
            Dataa.append('description', description);
            Dataa.append('video', video);
        } else {
            Dataa.append('vendor_id', vendor_id);
            Dataa.append('description', description);
            Dataa.append('image', image);
            Dataa.append('video', video);
        }*/
        Dataa.append('vendor_id', vendor_id);
        Dataa.append('description', description);
        Dataa.append('image', image);
        Dataa.append('video', video);

        axios.post(`${staticc}/api/story_add`, Dataa, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }).then((res) => {
            console.log(res);
            if (res.data.message == "success") {
                dispatch(addStories());
                dispatch(loadStories());
                notifysuccess(res.data.message)
                setloabBtn(false)
            }
        }).catch((err) => {
            console.log(err)
            setloabBtn(false)
            notifyError(err.response.data)
        })
    }
}